import React from 'react'

import useQuantity from 'app/components/base/QuantityInput/hooks/useQuantity'
import TextInputNumber from 'app/components/base/TextInputNumber'
import { TextFieldNumberProps } from 'app/components/fields/TextFieldNumber'

export type QuantityInputProps = TextFieldNumberProps & {
  disabled?: boolean
  maxValue?: number
  onChange?: (value: number) => void
}

const QuantityInput: RFC<QuantityInputProps> = ({
  disabled,
  maxValue,
  sx,
  ...props
}) => {
  const { negative, positive } = useQuantity({
    value: props.value,
    onChange: props.onChange,
    disabled,
    maxValue
  })

  return (
    <TextInputNumber
      sx={{
        '& .MuiInputBase-root': {
          padding: 0,
          height: '100%',
          fontWeight: 400,

          '& input': {
            padding: 0,
            textAlign: 'center'
          },

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D6DCE9'
          },

          '&.Mui-error': {
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'error.main'
            }
          }
        },
        maxWidth: 110,
        height: 31,
        ...sx
      }}
      disabled={disabled}
      startAdornment={negative}
      endAdornment={positive}
      decimalScale={0}
      {...props}
    />
  )
}

export default QuantityInput
